import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Highlights() {
  return (
    <section
      className="intro_section p-100"
      style={{ backgroundColor: "#F4F4F4" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#207146" }}>Highlights</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <p>
              In addition to building communities this application allows
              churches to run their establishments with increased efficiency. As
              organizations, churches can use this app to schedule services,
              notify their followers of programs and events, share information
              and updates, and directly transact with them as per their
              convenience.
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <StaticImage
              src="../../../images/case-studies/true-wine/highlights_img_1.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={792}
              height={687}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highlights;
